import { usePathname } from "next/navigation";
import ArrowLink from "../ArrowLink";
import Breadcrumbs from "../Breadcrumbs";
import styles from "./SubNav.module.css";
const SubNav: React.FC = () => {
  const pathname = usePathname();
  if (
    pathname === "/" ||
    pathname === "/locations" ||
    pathname === "/contact"
  ) {
    return false;
  }

  return (
    <div className={`${styles.subNav} grid-container`}>
      <div className="sm-col-span-8 lg-col-span-6">
        <Breadcrumbs />
      </div>
      <div className="sm-col-span-8 lg-col-span-6">
        <ArrowLink
          label="Find your next workspace"
          href="/locations"
          fullwidth
          border="bottom"
        />
      </div>
    </div>
  );
};
export default SubNav;
